import ImageCss from "./Image.module.scss";

export const LogoPlayerRow = (props: {
    src: string,
    alt: string,
    className?: string,
    isSmall?: boolean,
    onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>)=>void,
}) => {
    const svg = props.src.indexOf(".svg") > 0 ? ImageCss.svg : "";
    return <div onClick={props.onClick} className={`${ImageCss.PlayerRow} ${ImageCss.Box} ${props.className ?? ""} ${props.isSmall ? ImageCss.small : ""}`}>
        <img src={props.src} alt={props?.alt ?? ""} className={`${svg} LogoImage`}/>
    </div>
}
